module.exports = __webpack_public_path__ + "media/images/story/top/step5-755a2a64e8509e953438cef1b6ada599.svg";